import React__default, { useState, useEffect } from 'react';
import { PhoneField, Button } from '@deal/components';
import { useChatContext } from '../../../../containers/ChatContext/index.js';
import MessageBubbleText from '../../../MessageBubbleText/index.js';
import { ToastNotificationType } from '../../../../typings/index.js';
import { ConsumerRichCardEvents } from '../../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../../containers/RichCardEventEmitter/index.js';
import { isValidPhoneNumber } from '../../../../services/phone.js';
import Check from './check.svg.js';
import { ContactCollectionConsumerLeadComponent } from './ContactCollectionConsumerLead.generated.js';
import { ContactCollectionUpdatePhoneComponent } from './ContactCollectionUpdatePhone.generated.js';
import styles from './styles.css.js';

var ContactCollection = function ContactCollection(_a) {
  var message = _a.message,
      myself = _a.myself,
      richCard = _a.richCard;

  var _b = useChatContext(),
      tracking = _b.tracking,
      onToastNotification = _b.onToastNotification;

  var richCardEventEmitter = useRichCardEventEmitter();

  var _c = useState(undefined),
      phoneNumber = _c[0],
      setPhoneNumber = _c[1];

  var _d = useState(false),
      isPhoneNumberValid = _d[0],
      setIsPhoneNumberValid = _d[1];

  useEffect(function () {
    phoneNumber && setIsPhoneNumberValid(isValidPhoneNumber(phoneNumber));
  }, [phoneNumber]);
  var leadId = richCard.leadId;
  return React__default.createElement(ContactCollectionConsumerLeadComponent, {
    variables: {
      id: leadId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.lead) {
      var _b = data.lead,
          expert = _b.expert,
          consumer = _b.consumer;
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(MessageBubbleText, {
        myself: myself,
        message: message
      }, consumer.firstName ? "Hey " + consumer.firstName + "! " : "Hey! ", " Enjoying your conversation", expert.shortName ? " with " + expert.shortName + "?" : '?', " Get their help on the go - any time you want! You can turn off text alerts anytime by replying STOP"), React__default.createElement("div", {
        className: styles.phoneForm
      }, consumer.hasPhoneNumber ? React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles.successFormContent
      }, React__default.createElement("div", {
        className: styles.phoneFormIcon
      }, React__default.createElement(Check, {
        width: 32,
        height: 32
      })), React__default.createElement("div", {
        className: styles.phoneFormHeader
      }, "Success! Text messaging enabled"), React__default.createElement("div", {
        className: styles.followUp
      }, "Now you can call or text", ' ', expert.shortName ? expert.shortName : 'your expert', " anytime, anywhere")), React__default.createElement("div", {
        className: styles.followUpFooter
      }, "You can update notification preferences and any information directly from your", ' ', React__default.createElement("div", {
        onClick: function onClick() {
          richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: ConsumerRichCardEvents.VIEW_ACCOUNT_PAGE
          });
        },
        className: styles.followUpLink
      }, "Curated account"))) : React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles.phoneFormContent
      }, React__default.createElement("div", {
        className: styles.phoneFormHeader
      }, "Enter your phone number"), React__default.createElement("div", {
        className: styles.phone
      }, React__default.createElement(PhoneField, {
        label: "",
        errorText: phoneNumber && !isPhoneNumberValid ? 'Please enter a valid phone number' : undefined,
        labelHidden: true,
        autoFocus: true,
        onChange: function onChange(event) {
          return setPhoneNumber(event.target.value.replace(/\D/g, ''));
        },
        placeholder: "Phone number"
      })), React__default.createElement("div", {
        className: styles.terms
      }, "Message and data rates may apply. By submitting, you authorize Curated.com to send you automated text messages to alert you of deals and activity from your expert. You can turn off text alerts anytime by replying STOP.")), React__default.createElement(ContactCollectionUpdatePhoneComponent, {
        variables: {
          input: {
            phone: phoneNumber
          }
        },
        onCompleted: function onCompleted(response) {
          if (response && response.updateUserProfile && response.updateUserProfile.errors.length > 0) {
            onToastNotification && onToastNotification(ToastNotificationType.ERROR, response.updateUserProfile.errors.join(', '));
            return false;
          }

          tracking === null || tracking === void 0 ? void 0 : tracking.events.trackContactCollectionCardSubmitted();
          onToastNotification && onToastNotification(ToastNotificationType.SUCCESS, 'Successfully updated phone number.');
        },
        onError: function onError() {
          onToastNotification && onToastNotification(ToastNotificationType.ERROR, 'Error updating your phone number! Please try again.');
        }
      }, function (contactCollectionUpdatePhone, _a) {
        var loading = _a.loading;
        return React__default.createElement(Button, {
          className: styles.submit,
          onClick: function onClick() {
            return contactCollectionUpdatePhone();
          },
          disabled: !isPhoneNumberValid || loading
        }, "Submit");
      }))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

export default ContactCollection;
//# sourceMappingURL=index.js.map
